import { formatDate, parseISO, differenceInYears, isValid } from 'date-fns';

/** ISO 8601 date format (e.g. 2026-04-13) */
export const ISO_DATE_FORMAT = 'yyyy-MM-dd';

export const formatDateWithTime = (date: Date, format: string = 'MM/dd/yyyy, h:mm aa') => {
  return formatDate(date, format);
};

export const formatDateWithoutTime = (date: Date, format: string = 'MM/dd/yyyy') => {
  return formatDate(date, format);
};

/**
 * Formats a date string, Date, or epoch timestamp with the given format.
 * Date-only strings (no `T`) stay in calendar time. Invalid values return `String(date)`.
 * @param date - The date string, Date, or epoch milliseconds to format.
 * @param format - The format to use for the date string.
 * @returns {string} The formatted date string.
 */
export const formatDateTime = (date: string | Date | number, format?: string) => {
  const parsed = typeof date === 'string' && !date.includes('T')
    ? parseISO(date)
    : new Date(date);

  if (!isValid(parsed)) {
    return String(date);
  }

  if (typeof date === 'string' && !date.includes('T')) {
    return formatDateWithoutTime(parsed, format);
  }
  return formatDateWithTime(parsed, format);
};

export const isWithinOneYear = (startDate: Date, endDate: Date) => {
  return differenceInYears(endDate, startDate) < 1;
};
